/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { useQuery } from '@tanstack/react-query';

import { GetAlertConfigByIdResponse } from '@/client';
import { mgmtPlaneAPIClient } from '@/client/mgmtPlane';
import { useMgmtPlaneStateStore } from '@/state/mgmtPlaneStore';

export function useAlertConfigQuery(alertId: string | undefined) {
  const selectedTenantId = useMgmtPlaneStateStore((state) => state.selectedTenantID);

  return useQuery<GetAlertConfigByIdResponse>({
    queryKey: ['alertConfig', selectedTenantId, alertId],
    queryFn: () => {
      return mgmtPlaneAPIClient.alerts.getAlertConfigById({
        tenantId: selectedTenantId!,
        id: alertId!,
      });
    },
    enabled: !!selectedTenantId && !!alertId,
  });
}
